// extracted by mini-css-extract-plugin
export default {"altProgramList":"altProgramList__WXbqH"};